import {getInternalLinkOrigin} from '@toolify/client/src/modules/internalLinks/functions/getInternalLinkOrigin'

function getHostByOrigin(origin: string): string {
  try {
    return new URL(origin).host
  } catch {
    return ''
  }
}

export function getInternalLinkHosts(): string[] {
  const hosts = [
    ...(ENV.InternalLinkHosts ?? []),
    getHostByOrigin(getInternalLinkOrigin()),
    window.location.host,
  ].filter(Boolean)

  return Array.from(new Set(hosts))
}
